module.exports = __webpack_public_path__ + "img/l2-a.f7e4b28b.png";